import { css } from '@emotion/css';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../../../features';
import { replaceAllSpaces } from '../../../lib/utils';
import { NormalButton } from '../../shared/buttons/NormalButton';
import { reveal } from '../../shared/keyframe-animations';
import { MyDesignCanvas } from '../MyDesignCanvas';

const detailPagePath = '/players/my-design/detail';

export const MenuList: React.FC = () => {
  const { t } = useTranslation('translation');
  const history = useHistory();
  const { uploadedMyDesign } = useSelector((state: RootState) => state.myDesign);

  const canvasSize = 80;

  const handleDeleteClick = useCallback(() => {
    history.replace(`${detailPagePath}/menu/2`);
  }, [history]);

  const handleCancelClick = useCallback(() => {
    history.replace(detailPagePath);
  }, [history]);

  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        color: #4d3906;
        height: 100%;
        .image,
        .name,
        .delete,
        .cancel {
          opacity: 0;
          visibility: hidden;
          animation: 0.2s cubic-bezier(0.3, 0.82, 0.54, 1.23) ${reveal} both;
        }
        .image {
          flex: 0 0 auto;
          display: flex;
          justify-content: center;
          margin: 0 auto;
          animation-delay: 0.2s;
        }
        .name {
          text-align: center;
          animation-delay: 0.2s;
          padding: 8px 0;
        }
        .space {
          flex: 1 1 auto;
        }
        .delete,
        .cancel {
          transform: scale(0.9);
          margin: 12px 0 0;
        }
        .delete {
          animation-delay: 0.4s;
        }
        .cancel {
          animation-delay: 0.5s;
          margin-bottom: 4px;
        }
      `}
    >
      {uploadedMyDesign && (
        <>
          <div className="image">
            <MyDesignCanvas {...{ ...uploadedMyDesign, canvasSize }} />
          </div>
          <p className="name">{replaceAllSpaces(uploadedMyDesign.title)}</p>
        </>
      )}
      <div className="space" />
      <div className="delete">
        <NormalButton onClick={handleDeleteClick}>{t('button_delete')}</NormalButton>
      </div>
      <div className="cancel">
        <NormalButton onClick={handleCancelClick}>{t('dialog_button_cancel')}</NormalButton>
      </div>
    </div>
  );
};
